import {
  cellPhoneLabel,
  homePhoneLabel,
  personalEmailLabel,
  workEmailLabel,
  workPhoneLabel
} from '../strings/labels'

export const homePhoneField = {
  type: 'text',
  label: homePhoneLabel,
  name: 'home_phone'
}

export const cellPhoneField = {
  type: 'text',
  label: cellPhoneLabel,
  name: 'cell_phone'
}

export const workPhoneField = {
  type: 'text',
  label: workPhoneLabel,
  name: 'employment__phone'
}

export const personalEmailField = {
  type: 'text',
  label: personalEmailLabel,
  name: 'personal_email'
}

export const workEmailField = {
  type: 'text',
  label: workEmailLabel,
  name: 'employment__email'
}
